<div class="w-full border p-2 rounded-md bg-white shadow-sm border-gray-400">
  <!-- Header -->
  <div
    class="relative transition-all duration-200 cursor-pointer border-gray-400"
    (click)="isCollapsed = !isCollapsed"
    [ngClass]="{
      'border-b pb-2': !isCollapsed,
    }"
  >
    <p class="text-gray-600">
      <b>{{ titulo }}</b>
    </p>
    <span
      class="border-b-2 h-0 border-gray-600 block absolute right-3 top-1/2 -translate-y-1/2 transition-all duration-200 border-r-2"
      [ngClass]="{
        'w-4': isCollapsed,
        'rotate-45 h-3 w-3 top-[40%]': !isCollapsed
      }"
    ></span>
  </div>
  <div class="hide" [ngClass]="{ show: !isCollapsed }">
    <div>
      <div>
        <!-- Contenido -->
        <div class="block py-2">
          <ng-template *ngTemplateOutlet="contenidoHtml"></ng-template>
        </div>
        <!-- Contenido -->
      </div>
    </div>
  </div>
</div>
